<template>
    <v-main>
        <v-container fluid class="py-0">
            <v-row v-resize="resize">
                <v-col cols="12" sm="6" md="6" class="pa-0">
                    <div class="text-xs-center" style="position: relative;background-color: #444444;">
                        <div style="position: relative;">
                            <Videoplayer
                                    :activevideo="activevideo"
                                    :src="src"
                                    :poster="poster"
                                    :key="key"
                                    ref="vp"
                                    @userseeked="CheckSeeked($event)"
                                    @playbackrateactive="editnotevisible = !$event"
                                    @playing="Playing(true)"
                                    @pause="Playing(false)"
                            >
                            </Videoplayer>
                            <div class="loopmessage" v-if="looping">
                                <div class=" ol">Location {{displaylocation}}</div>
                            </div>
                            <div class="loopnote" v-if="shownotetools">
                                <div ref="notetextdiv" style="min-height:2em;"
                                     v-if="editnotevisible"
                                     contenteditable="true"
                                     @click="checkclear()"
                                     @blur="setnote()"
                                >
                                    {{notetext}}
                                </div>
                            </div>
                            <div class="loopnote" v-if="playingall">
                                <div ref="notetextdiv" style="min-height:2em;">
                                    {{notetext}}
                                </div>
                            </div>
                        </div>

                        <v-toolbar  dense dark>
                            <v-btn icon small @click="showclipnotes()" v-if="!shownotetools">
                                <v-icon>{{icons.edit}}</v-icon>
                            </v-btn>
                            <v-btn icon small @click="shownotetools=false" v-else>
                                <v-icon>{{icons.close}}</v-icon>
                            </v-btn>
                            <v-toolbar-title class="subheading">{{title}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                                <AddTagDialog @tag="addTag($event)" color="white" />
                                <v-btn text v-if="playing" @click="stop()"><v-icon>{{icons.pause}}</v-icon></v-btn>
                                <v-btn text v-if="!playing" @click="play()"><v-icon>{{icons.play}}</v-icon></v-btn>
                            </v-toolbar-items>
                        </v-toolbar>
                        <div v-if="shownotetools"
                             ref="scrubdiv"
                             style="border:solid thin #888888;margin-bottom:4px;padding-bottom: 0; background-color: lightgray;"
                             class="text-xs-left"
                        >
                            <div :style="'border:solid thin darkgrey; height:50px; width:100%; position:relative;'">
                                <div :style="`display:inline-block;position:absolute;left:0;top:0;width:72px;height:50px;background-image: url(${genthumb1});background-position: center;background-size:cover`"></div>
                                <div :style="`display:inline-block;position:absolute;right:0;top:0;width:72px;height:50px;background-image: url(${genthumb2});background-position: center;background-size:cover`"></div>
                                <div class="notecursor" :style="'left:'+noteprogress+'%;'"></div>
                                <div class="font-weight-light" style="display:inline-block;position:absolute;width:100%;text-align:center;top:10%;height:50px;">
                                    Clip Length: {{cliplength}} s
                                </div>
                            </div>
                        </div>
                        <VideoRangeSlider
                                v-if="shownotetools"
                                :start="notestart"
                                :end="noteend"
                                @update="Slider($event)"
                                @cliplength="cliplength = $event"
                        />
                        <v-btn v-if="shownotetools" text @click="savenote()" :loading="saving" outlined small class="float-right">
                            <v-icon class="mr-1">mdi-check-circle-outline</v-icon>
                            Save
                        </v-btn>
                    </div>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-list dense>
                        <v-subheader inset>
                            Select Notes/Tags
                        </v-subheader>
                        <v-list-item v-for="(t,i) in tags" :key="i" @click="handleNoteTags(i)">

                            <v-list-item-action @click="">
                                <v-checkbox v-model="notetags" :value="i"/>
                            </v-list-item-action>

                            <v-list-item-content>
                                <v-list-item-title v-text="t.firstname + ' ' + t.lastname"></v-list-item-title>
                                <v-list-item-subtitle>{{t.type}}</v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-avatar>
                                <img :src="t.profilepic"/>
                            </v-list-item-avatar>

                        </v-list-item>
                    </v-list>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-card outlined>
                        <v-list dense>
                            <v-list-item>
                                <v-list-item-content>
                                    <NoteSessions @selected="setSession($event)" />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item @click="notebooksdialog=true">
                                <v-list-item-action>
                                    <v-icon>mdi-bookshelf</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>Your Notebooks</v-list-item-title>
                                    <v-list-item-subtitle></v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>

                            <v-subheader inset>
                                Notes in this video
                            </v-subheader>

                            <v-list-item
                                    :disabled="shownotetools"
                                    v-if="!playingall"
                                    @click="playall()"
                            >

                                <v-list-item-action>
                                    <v-icon color="success">{{icons.play}}</v-icon>
                                </v-list-item-action>

                                <v-list-item-content>
                                    <v-list-item-title>Play All</v-list-item-title>
                                    <v-list-item-subtitle>

                                    </v-list-item-subtitle>
                                </v-list-item-content>

                            </v-list-item>

                            <v-list-item
                                    :disabled="shownotetools"
                                    v-else
                                    @click="stopPlayAll()"
                            >

                                <v-list-item-action>
                                    <v-icon color="info">{{icons.pause}}</v-icon>
                                </v-list-item-action>

                                <v-list-item-content>
                                    <v-list-item-title>Stop Play</v-list-item-title>
                                    <v-list-item-subtitle>

                                    </v-list-item-subtitle>
                                </v-list-item-content>

                            </v-list-item>

                            <v-list-item
                                    v-for="(t,i) in videonotes"
                                    :key="i"
                                    @click="editNote(t)"
                                    :style="`background-color: ${((playingall && noteid===t.id) || nid===t.nid )?'#C5CAE9':''};`"
                            >
                                <v-list-item-avatar size="40" tile v-if="nid!==t.nid">
                                    <img v-if="t.locationframe" :src="t.locationframe"/>
                                    <v-icon v-else :class="(noteid===t.id)?'blue darken-3 white--text':'grey lighten-1 white--text' ">
                                        {{t.icon}}
                                    </v-icon>
                                </v-list-item-avatar>
                                <v-list-item-action v-else>
                                    <v-btn icon><v-icon>{{icons.pause}}</v-icon></v-btn>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{t.firstname||'Unassigned' + ' ' + t.lastname||''}} | {{t.displaytime}}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{t.note}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-avatar>
                                    <img :src="t.profilepic"/>
                                </v-list-item-avatar>

                            </v-list-item>

                        </v-list>
                    </v-card>
                </v-col>
            </v-row>
            <v-dialog v-model="notebooksdialog" max-width="400">
                <v-card>
                    <v-card-text>
                        <v-list>
                            <v-list-item v-for="a in myathletes" @click="getNotesByTag(a.partkey)">
                                <v-list-item-avatar>
                                    <v-img :src="a.profilepic" />
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title>{{a.firstname}} {{a.lastname}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn text @click="notebooksdialog=false">Cancel</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="confirmdeletedialog" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">Delete Note</v-card-title>
                    <v-card-text></v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" text @click="confirmdeletedialog = false">Cancel</v-btn>
                        <v-btn color="green darken-1" text @click="deletenote()">Delete</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </v-main>
</template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'
  import Evaporate from 'evaporate'
  import crypto from 'crypto'
  import AWS from 'aws-sdk'
  import Videoplayer from '@/views/video/VideoJsPlayer'
  //import Videoplayer from '@/views/video/Videoplayer'
  import AddTagDialog from "@/components/tags/AddTagDialog";
  import NoteSessions from "@/views/notes/NoteSessions";
  import VideoRangeSlider from "./VideoRangeSlider";

  export default {
    name: 'VideoEditor',
    data() {
      return {
        confirmdeletedialog: false,
        shownotetextarea: true,
        addnotedialog: false,
        notetextdiv: '',
        scrubber: 400,
        genthumb1: '',
        genthumb2: '',
        gensave: '',
        fname: '',
        noteprogress: 0,
        shownotetools: false,
        notetags: [],
        videonotes: [],
        thumburl: 'https://videos.athleteforlife.org/',
        videourl: 'https://videos.athleteforlife.org/',
        imgurl: 'https://s3-us-west-2.amazonaws.com/imgforlife/',
        src: '',
        poster: '',
        videodialog: false,
        key: '',
        videoname: '',
        videoid: '',
        videoduration: '',
        tags: '',
        stags: false,
        string: '',
        playing: undefined,
        playbackrate: 1,
        notestart: 0,
        noteend: 0,
        notetext: 'Click to add text',
        noteloop: null,
        noteid: null,
        nid: null,
        editnotevisible: true,
        locationloop: null,
        looping: false,
        displaylocation: 0,
        renamevideodialog: false,
        tempvideo: '',
        video: '',
        editing: false,
        title: '',
        playallloop: '',
        playingall: false,
        notebooksdialog: false,
        saving: false,
        cliplength: 5
      }
    },
    components: {
      VideoRangeSlider,
      NoteSessions,
      AddTagDialog,
      Videoplayer
    },
    computed: {
      ...mapState(['activevideo', 'icons', 'cognito', 'orgkey', 'userpool', 'myathletes']),
      noteduration(){
        return (this.noteend - this.notestart)<5?5:(this.noteend - this.notestart)
      },
      min() {
        return (this.notestart - 2) < 0 ? 0 : (this.notestart - 2)
      },
      max(){
        return (this.noteend + 2) > this.duration ? this.duration : (this.noteend + 2)
      }
    },
    watch: {
      //if start changed by more than 2 sec, the end follows
      notestart: async function () {
        if (this.notestart >= this.noteend) {
          this.notestart -= 1
        }
        this.$refs.vp.Location = this.notestart;
        if (this.shownotetools) {
          this.getVideoImage()
        }
        //this.noteduration = this.noteend - this.notestart
      },
      noteend: async function () {
        if (this.noteend > this.$refs.vp.Duration) { //might be duplicate code now
          this.noteend = this.$refs.vp.duration
        }
        if (this.shownotetools) {
          this.getVideoImage()
        }
        //this.noteduration = this.noteend - this.notestart
        //console.log(this.noteduration)
      },
      shownotetools: function () {
        let em = this;
        this.duration = this.$refs.vp.Duration
        this.notestart = Math.round(this.$refs.vp.Location * 10) / 10;
        if (this.shownotetools) {
          this.$refs.vp.ShowControls()
          if (!this.editing) {
            this.notetext = 'Click to add text'
            this.title = 'New note'
          }
          this.buildscrubbar()
          this.$refs.vp.Seek(0);
          //this.noteduration = 5;
          this.videoduration = this.$refs.vp.duration;
          this.noteend = this.notestart + this.noteduration;
          em.looping = true;
          em.noteloop = setInterval(function () {
            if (em.$refs.vp.Location >= em.noteend) {
              em.$refs.vp.Seek((-1 * em.noteduration));
            }
          }, 100);
          em.locationloop = setInterval(function () {
            em.displaylocation = em.$refs.vp.Location.toFixed(2);
            em.noteprogress = (em.noteduration - (em.noteend - em.$refs.vp.Location)) / em.noteduration * 98
          }, 50);
          this.getVideoImage()
        } else {
          this.saving=false
          this.$refs.vp.PlaybackRate = 1;
          clearInterval(em.noteloop);
          clearInterval(em.locationloop);
          em.looping = false;
          em.clearSelected()
          this.notetext = 'Click to add text'
          em.$refs.vp.Seek(em.noteend)
          em.noteid = null
        }
      }
    },
    mounted() {
      let em = this;
      if (this.activevideo) {
        this.video = this.activevideo;
      } else if (window.localStorage.getItem('activevideo')) {
        this.video = JSON.parse(window.localStorage.getItem('activevideo'))
        this.setActiveVideo(this.video)
      } else {
        return this.$router.push('/myvideos')
      }
      this.key = this.video.partkey + this.video.sortkey;
      this.videodialog = true;
      this.src = this.videourl + this.video.info.url720p;
      this.poster = this.thumburl + this.video.info.thumb;
      this.videoname = this.video.name;
      this.videoid = this.video.sortkey;
      this.tags = this.video.tags2;
      this.tempvideo = document.createElement('video');
      this.tempvideo.crossOrigin = "anonymous";
      setTimeout(function () {
        em.notesInVideo()
        let l = window.localStorage.getItem('scrublocation');
        em.$refs.vp.Seek(parseFloat(l));
      }, 700)
    },
    updated() {
      if (this.shownotetools) {
        this.notetextdiv = this.$refs.notetextdiv
      }
    },
    beforeRouteLeave(to, from, next) {
      clearInterval(this.noteloop);
      clearInterval(this.locationloop);
      clearInterval(this.playallloop);
      next()
    },
    methods: {
      ...mapMutations(['setActiveVideo']),
      ...mapActions(['post','get','put']),
      Playing(e){
        this.playing=e
      },
      Slider(e){
        this.notestart = e[0]/10
        this.noteend = e[1]/10
      },
      CheckSeeked(val) {
        console.log('CHECKSEEKED', val)
        let ns = parseInt(val);
        let ne = this.noteend;
        if(ns >= ne){
          ne = ns + this.noteduration
          console.log('GREATERTHAN', ns,ne)
        }
        if(ne > this.duration){
          ne = this.duration;
          ns = ne-this.noteduration
        }
        this.noteend = ne;
        this.notestart = ns
      },
      setSession(e){
        console.log(e)
        this.notetags = e.uuid
      },
      addTag(event){
        this.$set(this.tags,event.playerurl,event)
        console.log(this.tags)
      },
      play() {
        this.$refs.vp.Play();
      },
      stop() {
        this.$refs.vp.Pause();
      },
      showclipnotes() {
        this.shownotetools = true;
        console.log(this.notestart);
      },
      tagd() {
        this.$store.commit('tagdialog', true)
      },
      getVideoImage() {
        let ig = 1;
        var em = this, video = this.tempvideo;
        video.onloadedmetadata = function () {
          if ('function' === typeof secs) {
            secs = secs(this.duration);
          }
          this.currentTime = em.notestart;
        };
        video.onseeked = function (e) {
          var canvas = document.createElement('canvas');
          canvas.height = video.videoHeight;
          canvas.width = video.videoWidth;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          //var img = new Image();
          if (ig === 1) {
            em.genthumb1 = canvas.toDataURL('image/jpeg', .8)
            canvas.toBlob(function (blob) {
              em.gensave = blob;
            }, 'image/jpeg', 0.8)
            this.currentTime = em.noteend;
            ig = 2
          } else {
            em.genthumb2 = canvas.toDataURL('image/jpeg', .8)
          }
        };

        video.onerror = function (e) {
          console.log("videoerror", e)
        };
        video.src = this.src;
      },
      resize() {
        if (this.shownotetools) {
          this.buildscrubbar();
        }
      },
      buildscrubbar() {
        let em = this;
        setTimeout(function () {
          let w = em.$refs.scrubdiv.clientWidth;
          em.scrubber = w - 72 - 72 - 10
        }, 100)
      },
      stepforward() {
        let t = this.$refs.vp.Location + .1;
        this.stop();
        this.$refs.vp.Seek(t)
        this.displaylocation = t.toFixed(2);
        console.log(t, this.displaylocation)
      },
      stepbackward() {
        let t = this.$refs.vp.Location - .1;
        this.stop();
        this.$refs.vp.Seek(t)
        this.displaylocation = t.toFixed(2);
        console.log(t, this.displaylocation)
      },
      checkclear() {
        if (this.notetext === 'Click to add text') {
          this.notetext = ''
        }
      },
      setnote() {
        this.notetext = this.notetextdiv.innerText
      },
      async getNotesByTag(tag){
        let response = await this.get({path:'api/notes/notesbytag/'+tag})
        console.log(response)
        this.videonotes = response
        this.notebooksdialog=false
      },
      handleNoteTags(tagkey) {
        if (this.notetags.includes(tagkey)) {
          this.notetags.splice(this.notetags.indexOf(tagkey), 1)
        } else {
          this.notetags.push(tagkey)
        }
      },
      async notesInVideo() {
        //SAVES A VIDEO NOTE
        let response = await this.get({path:'api/notes/notesinvideo/' + this.video.partkey + '/' + this.video.sortkey})
        console.log(response)
        this.videonotes = response
      },
      editNote(note) {
        console.log('NPOTE',note)
        if(this.nid===note.nid){
          this.clearSelected()
          return
        }
        clearInterval(this.playallloop)
        this.notetags = [note.tag]
        this.title = 'Editing Note: ' + note.note
        this.editing = true;
        this.shownotetools = true
        this.noteid = note.id
        this.nid = note.nid
        this.notestart = note.videotimestamp;
        this.noteend = this.notestart + note.duration;
        this.notetext = note.note;
        this.$refs.vp.PlaybackRate = note.playbackrate;
        console.log(this.noteend)
      },
      playall() {
        let em = this;
        let i = -1;//will get triggered at start of interval loop
        let ed = 0;
        let ln = em.videonotes.length - 1; //because of how we are setting i, need -1
        em.playingall = true
        em.$refs.vp.PlaybackRate = .5;
        this.shownotetools = false
        this.title = 'Playing All'
        this.playallloop = setInterval(function () {
          console.log('loop')
          if (em.$refs.vp.Location > ed && i < ln) {
            i++;
            console.log(ln, i, em.noteid, 'Changing')
            em.noteid = em.videonotes[i].id
            em.notetext = em.videonotes[i].note
            ed = em.videonotes[i].videotimestamp + em.videonotes[i].duration
            em.$refs.vp.Location = em.videonotes[i].videotimestamp;
            em.$refs.vp.PlaybackRate = em.videonotes[i].playbackrate;
          }
          if (i === ln) {
            clearInterval(em.playallloop)
            em.playingall = false
            em.title = 'New Note'
            em.notetext = 'Click to add text'
            em.stop()
          }
        }, 200);
      },
      stopPlayAll(){
        this.playingall=false
        clearInterval(this.playallloop)
        this.stop()
        this.clearSelected()
      },
      confirmdelete() {

      },
      deletenote() {
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/notes/savenote',
          method: 'DELETE',
          data: {
            id: this.noteid,
            type: 'video',
            tag: this.notetags,
            partkey: this.video.partkey,
            sortkey: this.video.sortkey,
            notestart: (Math.round(this.notestart * 100) / 100),
            noteduration: (Math.round(this.noteduration * 100) / 100),
            body: this.notetext,
            noteplaybackrate: this.$refs.vp.PlaybackRate,
            orgkey: this.$store.state.appdata.a4lorg.partkey
          }
        }
      },
      clearSelected() {
        this.noteid = null;
        this.nid = null;
        this.notetext = 'Click to add text';
        this.title = 'New note';
        this.shownotetools = false
        this.stop()
      },
      async savenote() {
        this.saving=true;
        this.fname = this.$store.state.orgkey + '/' + Math.floor(1000000000 * Math.random());
        let data = {
          id: this.noteid,
          type: 'video',
          tag: this.notetags,
          partkey: this.video.partkey,
          sortkey: this.video.sortkey,
          notestart: (Math.round(this.notestart * 100) / 100),
          noteduration: (Math.round(this.noteduration * 100) / 100),
          body: this.notetext,
          noteplaybackrate: this.$refs.vp.PlaybackRate,
          locationframe: this.imgurl + this.fname + '.jpg',
          poster: this.poster,
          src: [{type:'video/mp4',src:this.src}]
        }
        let response = await this.put({path:'api/notes/savenote',body:data})
        this.saving=false
        this.shownotetools = false;
        this.notetext = '';
        this.noteid = null;
        this.saveimage()
        this.notesInVideo()
      },
      async saveimage() {
        var em = this;
        var file = new File([em.gensave], 'tmp.jpg', {type: "image/jpeg"});
        var filePromises = [], allCompleted;
        let session = await this.$store.dispatch('cognito/fetchSession');
        Evaporate.create({
          signerUrl: em.$store.state.url + 'api/mobile/signv4_authv2',
          signHeaders: {
            'Authorization': 'Bearer '+ session.accessToken.jwtToken,
            'Pool': this.userpool
          },
          aws_key: 'AKIAIERQHVC6LFNJNTVA',
          awsRegion: 'us-west-2',
          bucket: 'imgforlife',
          awsSignatureVersion: '4',
          computeContentMd5: true,
          cryptoMd5Method: function (data) {
            return AWS.util.crypto.md5(data, 'base64');
          },
          cryptoHexEncodedHash256: function (data) {
            return AWS.util.crypto.sha256(data, 'hex');
          }
        })
          .then(function (evaporate) {

              //var file = em.image;//  em.$refs.file.files[0];

              //foreach file, evaporate
              for (var i = 0; i < 1; i++) {
                var ct = i;
                var type = 'mime/jpeg';
                var size = '400X400';
                var ext = 'jpg';
                var filename = em.fname;
                var promise = evaporate.add({
                  name: filename + '.' + ext,
                  file: file,
                  xAmzHeadersAtInitiate: {
                    'x-amz-acl': 'public-read',
                    'content-type': type,
                    'x-amz-storage-class': 'STANDARD'
                  },
                  progress: function (progress) {
                    console.log('making progress: ' + progress);
                    em.progress = progress * 100;
                  }
                })
                  .then(function (awsKey) {
                    console.log('ALL COMPLETE ', awsKey, 'complete!');
                    //em.uploaded = false
                    //em.savepic(awsKey)
                  });
                filePromises.push(promise);
              }
              return allCompleted = Promise.all(filePromises)
                .then(function () {
                  return console.log('All files were uploaded successfully.');

                }, function (reason) {
                  console.log('All files were not uploaded successfully:', reason);
                });

            },
            function (reason) {
              console.log('Evaporate failed to initialize: ', reason)
            }
          );
      }
    }
  }

</script>

<style scoped>
    .notecursor{
        width:4px;
        height:50px;
        background-color: darkblue;
        border: solid thin #232323;
        position: absolute;
    }
    .imagebox{
        display:inline-block;
        position:absolute;
        top:0;
        width:72px;
        height:50px;
        background-position: center;
        background-size:cover
    }
    .ol{
        color: white;
        -webkit-text-fill-color: white; /* Will override color (regardless of order) */
        -webkit-text-stroke-width: 1px;
        -webkit-text-stroke-color: black;
    }
    .start{
        vertical-align: middle;
        display: inline-block;
        border:solid thin black;
        border-radius: 3px;
        width:80px;
        text-align: center;
    }
    .starticons{
        vertical-align: middle;
        display: inline-block;
        color:black;
    }
    .loopmessage{
        display: block;
        position:absolute;
        top:0;
        z-index:999;
        font-size: 1.5em;
        font-weight: bold;
        color:#fff;
        width:100%;
        height:200px;
    }
    .loopnote{
        display: block;
        position:absolute;
        bottom:100px;
        z-index:999;
        color:#fff;
        background-color: rgba(0,0,0,.5);
        width:100%;
        cursor: pointer;
    }
    .full{
        width: auto;
    }
    .infobox {
        border: solid thin #555555;
        border-radius:3px;
        padding:5px;
        display: inline-block;
        width:60px;
        text-align: left;
        float: right;
    }
    .tagsearcher{
        width:200px;
    }
    .videoplayer{
        max-height: 400px;
    }
    .playicon{
        transform: scale(3);
        width:auto;
        left:50%;
        position: absolute;
        top:50%;
        color:pink;
    }
    .vidcontainer{
        z-index:4 !important; /*needs to be higher than the <footer>, so that it fullscreens whe it rotates*/
        position:fixed;
        top:0;left:0;
        background-color: #888888;
        width:100%;
        height:auto;
        text-align: center;
    }
    .videoplayer{
        width:100%;
        max-width:1920px;
    }
    .a4ltools{
        position:absolute;
        top:0;left:0;
        width:100%;
        max-width:1920px;
        height:50px;
        border:solid thin #FFF;
    }
    .a4ltoolbtn{
        height: 100%;
        width:50px;
        border:solid thin #fff;
        line-height: 80%;
        vertical-align: middle;
        font-size: 2em;
        color:#FFFFFF;
        float: left;
    }
    .a4lpress{
        position:absolute;
        top:50px;left:0;
        width:100%;
        max-width:1920px;
        height:100%;
        border:solid thin #00acc1;
    }
    .rotate-transition {
        transition: all .3s ease;
        transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
    }
    .rotate.v-enter, .rotate.v-leave {
        transition: all .3s ease;
        transform: rotate(-90deg);
        -webkit-transform: rotate(-90deg);
    }
    .videocard{
        padding:0;
        margin-bottom: 10px;
        width:100%;
        height:200px;
        background-color: #111111;
        color:#FFF;
    }
    .cardcontainer {
        width:100%
    }
    .superfloat{
        z-index:10
    }
</style>
